<template>
  <div class="root">
    <video v-if="!missing" :loop="blok.loop" :muted="blok.muted" :poster="poster" :controls="blok.controls"
      :autoplay="blok.autoplay" :style="styleMap">
      <source v-if="url" :src="url">
      <span>Your browser does not support video</span>
    </video>
    <div v-else class="missing" :style="styleMap">
      <p>
        <translate>Video Not Found</translate>
      </p>
    </div>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-video",
  data() {
    return {
      url: null,
      poster: null,
      missing: false,
    };
  },
  async fetch() {
    try {
      const { data: { results: details } } = await this.$api.get(`public_api/misc/marketing_videos/${this.blok.key}`)
      let lang = `_${this.$route.params.language}`;
      lang = lang.replace("_en", "")
      this.url = details[`video${lang}`] ?? details['video']
      this.poster = details[`thumbnail${lang}`] ?? details['thumbnail']
    } catch (e) {
      this.missing = true
    }
  },
  computed: {
    styleMap() {
      return {
        'aspect-ratio': this.emptyValue(this.blok.aspect_ratio) ? 'initial' : this.blok.aspect_ratio,
        'object-fit': this.emptyValue(this.blok.video_fit) ? 'initial' : this.blok.video_fit,
      }
    }
  }
}
</script>

<style scoped>
video {
  border-radius: 10px;
  width: 100%;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

div.missing {
  border-radius: 10px;
  width: 100%;
  display: grid;
  place-items: center;
  min-height: 100%;
  background-color: #efefef;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}
div.missing p {
  margin: 0;
  padding: 0;
}
</style>
